import { h } from 'preact';

// action {
//  onclick:callback:
//  target: string;
//  href: string;
// }
export default function ({ icon, name, tooltip, isVisible, link }) {

  const { href, onclick, target } = link;

  return (
    <li class={"fab-buttons__item " + (isVisible ? "" : "hide")}>
      <a href={href} target={target} class="fab-item__color fab-buttons__link" onClick={onclick}>
        <div id={name} class="fab-item__icon" dangerouslySetInnerHTML={{ __html: icon }}/>
      </a>

      <div class="link__tooltip-wrapper">
        <div class="tooltip-wrapper__tooltip" onClick={onclick}>
          <div class="fab-item__color tooltip__content-wrapper">
            {target ?
              (<a href={href} target={target} class="link-element">
                <div id={name + "__tooltip"} class="tooltip__content">{tooltip}</div>
              </a>) :
              (<div id={name + "__tooltip"} class="tooltip__content">{tooltip}</div>)
            }
          </div>
        </div>
      </div>
    </li>
  )
}
